'use client';

import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type Theme } from '@/lib/theme';

/**
 * Переключатель темы на три положения.
 *
 * Именно три, а не выключатель: «как в системе» — не то же самое, что
 * «светлая». Выключатель заставил бы человека выбирать заново каждый раз,
 * когда ОС переключается по расписанию.
 */

const options: { value: Theme; icon: React.ReactNode; title: string }[] = [
  { value: 'light', icon: <Sun size={13} />, title: 'Светлая' },
  { value: 'dark', icon: <Moon size={13} />, title: 'Тёмная' },
  { value: 'system', icon: <Monitor size={13} />, title: 'Как в системе' },
];

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex gap-0.5 bg-slate-100 p-0.5 rounded-md" role="group" aria-label="Тема">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => setTheme(option.value)}
          title={option.title}
          aria-label={option.title}
          aria-pressed={theme === option.value}
          className={`p-1.5 rounded transition-colors ${
            theme === option.value
              ? 'bg-white text-brand-accent shadow-sm'
              : 'text-slate-400 hover:text-slate-600'
          }`}
        >
          {option.icon}
        </button>
      ))}
    </div>
  );
}
